import { useEffect, useState } from 'react';
import { getToDoList } from '../../api/constlink';
import ToDoListComponent from '../../components/projects/ToDoListComponent';
import { Col, Row, Spin } from 'antd';

interface ToDoListContainerProps {
  enterpriseId: string;
}

function ToDoListContainer({ enterpriseId }: ToDoListContainerProps) {
  const [loading, setLoading] = useState(false);
  const [todos, setTodos] = useState<any>();
  useEffect(() => {
    (async () => {
      setLoading(true);
      const response = await getToDoList({ enterpriseId });
      setTodos(response);
      setLoading(false);
    })();
  }, [enterpriseId]);

  return (
    <>
      {loading && (
        <Row justify={'center'}>
          <Col>
            <Spin />
          </Col>
        </Row>
      )}
      {todos && <ToDoListComponent todos={todos} />}
    </>
  );
}

export default ToDoListContainer;
